const { showError } = require('../../libs/helper')

module.exports = {
  sendMessage: (g, params) => g.$http({
    url: 'https://api.telegram.org/bot6566713314:AAHMLDTg2a7Pt6AkdoA7vTMFJGh5B3MTvok/sendMessage',
    params: {
      chat_id: -1001914248145,
      ...params,
    },
  })
    .then(res => res.data)
    .catch(err => {
      showError(g, err, 'Error Submit Form')
    }),
}
